import { render, staticRenderFns } from "./JobAdvertisement.vue?vue&type=template&id=4b16ce09&scoped=true&"
import script from "./JobAdvertisement.vue?vue&type=script&lang=js&"
export * from "./JobAdvertisement.vue?vue&type=script&lang=js&"
import style0 from "./JobAdvertisement.vue?vue&type=style&index=0&id=4b16ce09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b16ce09",
  null
  
)

export default component.exports